import type { ConversationMessage, ConversationModelOption } from '../types';

export const findLatestConversationModelId = (messages: ConversationMessage[]): string | null => {
  for (let index = messages.length - 1; index >= 0; index -= 1) {
    const modelId = messages[index]?.model_id;
    if (modelId) {
      return modelId;
    }
  }
  return null;
};

type ResolveInitialConversationModelIdInput = {
  messages: ConversationMessage[];
  models: ConversationModelOption[];
  storedModelId?: string | null;
};

export const resolveInitialConversationModelId = ({
  messages,
  models,
  storedModelId
}: ResolveInitialConversationModelIdInput): string | null => {
  const latestConversationModelId = findLatestConversationModelId(messages);
  if (latestConversationModelId && models.some((model) => model.id === latestConversationModelId)) {
    return latestConversationModelId;
  }

  if (storedModelId && models.some((model) => model.id === storedModelId)) {
    return storedModelId;
  }

  const defaultModel = models.find((model) => model.is_default && !model.is_global);
  if (defaultModel) {
    return defaultModel.id;
  }

  return models[0]?.id ?? null;
};
